import { combineReducers } from '@reduxjs/toolkit'

import platform from './platform'
import reset from './reset'
import verify from './verify'

export default combineReducers({
  platform,
  reset,
  verify,
})
